import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

@Component({

  selector: 'app-s1040',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './s1040.component.html',
  styleUrls: ['./s1040.component.scss']
})
export class S1040Component implements OnInit {
  Form: FormGroup;
  dados: any = {};

  validacao_mensagens = {
    tipo: [{ type: 'required', message: 'Tipo é requerido' }]
  };

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<S1040Component>,
    private utilServico: UtilServico,
    private utilDadosLogado: UtilDadosLogado,
    private router: Router
  ) {
    this.Form = fb.group({
      tipo: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.dados.tipo = 'I';
  }

  Salvar(): void {
    if (this.Form.valid) {
      const { usuario_id, db_config } = this.utilDadosLogado.DadosAcesso();

      this.utilServico
        .Post(
          'TabelaRubrica/S1010',
          {
            tipo_xml: this.dados.tipo,
            usuario_id,
            db_config
          },
          true
        )
        .subscribe(
          data => {
            console.log(data.Ambiente);
            var event = document.createEvent('CustomEvent');
            event.initCustomEvent("EnviarDadosString", true, true, {
              'metodo': 'ExEsocial',
              'xml': data.xml,
              'ambiente': data.Ambiente,
              'retaguarda': data.Retaguarda,
              'ws': this.utilDadosLogado.DadosAcesso().url
            }
            );
            document.documentElement.dispatchEvent(event);
          },
          error => {
            swal.fire({
              title: 'Atenção!',
              type: 'error',
              text: error._body
            });
          }
        );
    }
  }
}
